<template>
    <div class="shipping-time" v-show="show">
        <div class="week-select">
          <el-checkbox-group v-model="selectedDays" @change="handleDaysChange">
            <el-checkbox v-for="(day, index) in weekDays" :key="index" :label="index">
              {{ day }}
            </el-checkbox>
          </el-checkbox-group>
        </div>
   
      <div class="time-slots-container">
        <div class="time-slot-item" v-for="(slot, slotIndex) in timeSlots" :key="slotIndex">
          <el-time-picker 
            v-model="slot.start" 
            format="HH:mm"
            placeholder="请选择时间"
            clearable="true"
            :class="{'is-error': showError && !isValidTimeSlot(slot)}"
            @change="validateTimeSlot(slotIndex)"
          />
          <span class="separator">-</span>
          <el-time-picker 
            v-model="slot.end" 
            format="HH:mm"
            placeholder="请选择时间"
            :class="{'is-error': showError && !isValidTimeSlot(slot)}"
            @change="validateTimeSlot(slotIndex)"
          />
          <el-button 
            v-if="timeSlots.length  > 1"
            type="text"
            class="delete-btn"
            @click="removeTimeSlot(slotIndex)"
          >
            删除 
          </el-button>
        </div>
   
        <div class="add-btn-wrap">
          <el-button 
            v-if="timeSlots.length  < 6"
            type="text"
            class="add-btn"
            @click="addTimeSlot"
          >
            + 添加 
          </el-button>
        </div>
      </div>
    </div>
  </template>
   
  <script>
  import dayjs from 'dayjs';
   
  export default {
    name: 'ShippingTime',
    props: {
      value: {
        type: Array,
        default: () => Array(7).fill([])
      },
      show: {
        type: Boolean,
        default: false 
      }
    },
    data() {
      return {
        weekDays: ['周一', '周二', '周三', '周四', '周五', '周六', '周日'],
        selectedDays: [0, 1, 2, 3, 4, 5, 6], // 默认选中所有天
        timeSlots: [{ start: '', end: '' }], // 使用单一时间段数组 
        showError: false ,
        checked: false,
      };
    },
    watch: {
      value: {
        handler(newVal) {
          this.initTimeData(newVal); 
        },
        immediate: true 
      },
    },
    methods: {
      initTimeData(data) {
        if (!Array.isArray(data))  return;
   
        // 如果是空数据，保持默认全选状态
        if (data.every(day => day.length === 0)) {
          this.selectedDays = [0, 1, 2, 3, 4, 5, 6];
          this.timeSlots = [{ start: '', end: '' }];
          return;
        }
      
        const firstDayWithData = data.find(day  => day.length  > 0) || [];
        this.timeSlots  = firstDayWithData.map(timeStr  => {
          const [start, end] = timeStr.split('-'); 
          return {
            start: this.parseTimeString(start), 
            end: this.parseTimeString(end) 
          };
        });
   
        if (this.timeSlots.length  === 0) {
          this.timeSlots  = [{ start: '', end: '' }];
        }
   
        this.selectedDays  = data.reduce((acc,  day, index) => {
          if (day.length  > 0) acc.push(index); 
          return acc;
        }, []);
      },
      parseTimeString(timeStr) {
        if (!timeStr) return '';
        const [hours, minutes] = timeStr.split(':').map(Number); 
        const date = new Date();
        date.setHours(hours); 
        date.setMinutes(minutes); 
        return date;
      },
      addTimeSlot() {
        if (this.timeSlots.length  < 6) {
          // this.timeSlots.push({  start: '', end: '' });
          this.$set(this.timeSlots, this.timeSlots.length, { start: '', end: '' });
          this.emitValue(); 
        }
      },
      removeTimeSlot(index) {
        if (this.timeSlots.length  > 1) {
          this.timeSlots.splice(index,  1);
          this.emitValue(); 
        }
      },
      validateTimeSlot(index) {
        console.log(index,136);
        const slot = this.timeSlots[index]; 
        if (slot.start  && slot.end  && !this.isValidTimeSlot(slot))  {
          this.$message.warning(' 结束时间必须晚于开始时间');
        }
        this.emitValue(); 
      },
      isValidTimeSlot(slot) {
        if (!slot.start  || !slot.end)  return false;
        return dayjs(slot.end).isAfter(dayjs(slot.start)); 
      },
      emitValue() {
        this.$emit('input', this.formatOutput()); 
      },
      formatOutput() {
        console.log(this.timeSlots,148,this.selectedDays);
        const validSlots = this.timeSlots.map(slot => {
          const start = slot.start ? dayjs(slot.start).format('HH:mm') : '';
          const end = slot.end ? dayjs(slot.end).format('HH:mm') : '';
          if(!start && !end){
            return ''
          }
          return `${start}-${end}`;
        });
        // const validSlots = this.timeSlots
        // .filter(slot => {
        //   // 只要有开始时间或结束时间就为有效
        //   return (slot.start || slot.end);
        // })
        // .map(slot => {
        //   const start = slot.start ? dayjs(slot.start).format('HH:mm') : '00:00';
        //   const end = slot.end ? dayjs(slot.end).format('HH:mm') : '23:59';
        //   return `${start}-${end}`;
        // });
        console.log(validSlots,'validSlots',Array(7).fill(null).map((_, index) =>
          this.selectedDays.includes(index)  ? validSlots : []
        ));
        return Array(7).fill(null).map((_, index) =>
          this.selectedDays.includes(index)  ? validSlots : []
        );
      },
      handleDaysChange(selectedDays) {
        this.selectedDays  = selectedDays;
        this.emitValue(); 
      }
    }
  };
  </script>
   
  <style lang="scss" scoped>
  .shipping-time {
    background: #f5f7fa;
    border-radius: 4px;
    padding: 16px;
   
    .week-select {
      margin-bottom: 15px;
      padding-bottom: 10px;
      border-bottom: 1px solid #dcdfe6;
   
      :deep(.el-checkbox-group) {
        display: flex;
        gap: 16px;
      }
    }
   
    .time-slots-container {
      .time-slot-item {
        display: flex;
        align-items: center;
        margin-bottom: 10px;
   
        .separator {
          margin: 0 10px;
        }
   
        .delete-btn {
          margin-left: 10px;
          color: #ff7043;
        }
      }
   
      .add-btn-wrap {
        margin-top: 16px;
        .add-btn {
          color: #409eff;
        }
      }
    }
  } 
  </style>